var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71354 1.33301C5.03354 1.33301 2.04688 4.31967 2.04688 7.99967C2.04688 11.6797 5.03354 14.6663 8.71354 14.6663C12.3935 14.6663 15.3802 11.6797 15.3802 7.99967C15.3802 4.31967 12.3935 1.33301 8.71354 1.33301ZM9.38021 11.333H8.04688V9.99967H9.38021V11.333ZM9.38021 8.66634H8.04688V4.66634H9.38021V8.66634Z",
    fill: "#F5BF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.97b077014fbe3dbe719daf1ffee3fdd8.svg";
export { ForwardRef as ReactComponent };